module.exports = __webpack_public_path__ + "img/truck03.5e18c9ff.png";